<template>
    <div class="remarkItem" >
      <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
        <van-list
          v-model="loading"
          :finished="finished"
          :offset="offset"
        >
          <div class="commission-item" v-for="(item, i) in dataList" :key="i">
            <div class="item" @click="onContent(item.RemarkContent)" >
              {{ item.RemarkContent }}
            </div>
          </div>
        </van-list>
      <!-- </van-pull-refresh> -->
    </div>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        options: {
          type: "getCustomRemarkList",
          pageIndex: 1,
          classId: this.tid,
        },
        offset: 100,
        refreshing: false,
        loading: true,
        finished: false,
        dataList: [],
      };
    },
    props: {
      tid: Number,
    },
    methods: {
      init() {
        this.getList();
      },
      onRefresh() {
        this.finished = false;
        this.loading = true;
        Object.assign(this.options, {
          current: 1
        });
  
        this.getList();
      },
      loadMore() {
        Object.assign(this.options, {
          current: this.options.pageIndex + 1,
        });
  
        this.loading = true;
        this.getList();
      },
      getList() {
        var that = this;
        var _options = that.options;
        this.$store.dispatch(_options).then(
          (res) => {
            console.log(res, "getList");
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }
  
            if (res.data.length <= 0) {
              that.finished = true;
            }
            if (_options.current > 1) {
              if (res.data.length > 0) {
                res.data.forEach((element) => {
                  that.dataList.push(element);
                });
              }
            } else {
              that.dataList = res.data;
              that.finished=true;
            }
          },
          (error) => {
            console.log(error);
          }
        );
      },
      onContent(content){
        if(content!="")
        {
          this.$emit("changContent", content);
        }
      
      }
    },
    created() {
      this.init();
    },
  };
  </script>
  
  <style  lang="less" >
  .remarkItem{
    // padding: 10px;
  
  }
  .commission-item{
    background-color: #69BBA0;
    color: white;
    margin:4px;
    .item{
      display: flex;
    line-height: 20px;
    padding: 8px;
    }
    
  }
  
  </style>
  